import React, { useState, useContext, useEffect, Fragment } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { ObjModal } from '../../../../contexts';
import AddOffer from '../../../Modals/AddOffer';
import { FaRegTrashAlt } from 'react-icons/fa';
import { removeOffer } from '../../../../common/api';
import { toast } from 'react-toastify';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { formatShorthand, monthsShort } from '../../../../common/utils';


const Offers = ( { aid, uid } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.offers.length > 0 );
    }, [ obj.offers ] );

    const trash = async ( oaid,oid ) => {
        const removed = await removeOffer( oaid, uid, oid );
        if ( removed.length ) {
            toast.success( 'The offer has been deleted', { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const formatDate = ( d ) => {
        if ( d ) {
            const [ yr, mon, dd ] = d.replace( /[T\s].*/, '' ).split( '-' );
            return `${monthsShort[parseInt(mon) - 1]} ${dd}, ${yr}`;
        }
        return '';
    }

    const handleModal = ( t, lid, name ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'offer':
                setModal( <AddOffer close={closeModal} l={obj} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Offers ({obj.offers.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'offer' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    {
                        obj.offers.map( o => {
                            return (
                                <ListGroup.Item key={o.id}>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='tf-sidebar-obj-value'>
                                            { ( o.type === 'quote' ) ? 'Quote' : o.status }
                                        </Col>
                                        <Col>
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='tf-sidebar-obj-key-date-container'>
                                                    <span className='tf-sidebar-obj-key-date'>
                                                        <Link to={`/offer/${o.oid}`}>{ ( o.subjectAddress ) ? o.subjectAddress : 'TBD' }</Link>
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='tf-sidebar-obj-desc'>
                                                    ${formatShorthand( o.price )}{ ( o.rate ) ? ( <Fragment>@ {o.rate}%</Fragment> ) : ( null ) } on {formatDate( o.offerDate )}
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( o.aid, o.oid ) } /></Col>
                                    </Row>
                                </ListGroup.Item>
                            )
                        } )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( Offers );